module.exports = __webpack_public_path__ + "img/Flip Card 4.770099ed.svg";